import {createRoot} from 'react-dom/client';

import {
    Provider
} from 'react-redux';

import {
    configureStore
} from '@js/stores';

import BlogArticleShow from '@js/components/blogs/article';

require('@js/common');

const article = JSON.parse(document.getElementById('article-blog-show-component').getAttribute('data-article'));

const root = createRoot(document.getElementById('article-blog-show-component'));
root.render(
    <Provider store={configureStore}>
        <BlogArticleShow article={article}/>
    </Provider>
);
